<template>
  <img src="~/assets/img/logo.png" alt="Borracho Pescador">
</template>
